import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Typography } from '@mui/material';

import { StyledCreateInvoice } from './index.style';

const CreateInvoice = ({ invoice, error, onChangeInvoice, disableInvoice }) => {
  const { t } = useTranslation();

  return (
    <StyledCreateInvoice>
      <div>
        <Typography>
          {t('companyName')} <span>*</span>
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          data-id="input-company-name"
          placeholder={t('companyPlaceHolder')}
          className="invoice-input"
          value={invoice.companyName}
          name="companyName"
          onChange={onChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10, readOnly: disableInvoice }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="company-name"
              data-message={t(error.companyName)}
              data-form-name="payment-info"
            >
              {t(error.companyName)}
            </span>
          }
          error={!!error.companyName}
        />
      </div>
      <div>
        <Typography>
          {t('address')} <span>*</span>
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          placeholder={t('companyAddress')}
          className="invoice-input"
          value={invoice.companyAddress}
          name="companyAddress"
          onChange={onChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10, readOnly: disableInvoice }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="company-address"
              data-message={t(error.companyAddress)}
              data-form-name="payment-info"
            >
              {t(error.companyAddress)}
            </span>
          }
          error={!!error.companyAddress}
          data-id="input-company-address"
        />
      </div>
      <div>
        <Typography>
          {t('taxNumber')} <span>*</span>
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          placeholder={t('taxNumber')}
          className="invoice-input"
          value={invoice.companyTax}
          name="companyTax"
          onChange={onChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10, readOnly: disableInvoice }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="tax-code"
              data-message={t(error.companyTax)}
              data-form-name="payment-info"
            >
              {t(error.companyTax)}
            </span>
          }
          error={!!error.companyTax}
          data-id="input-tax-code"
        />
      </div>
      <div>
        <Typography>
          {t('receivedInvoiceEmail')} <span>*</span>
        </Typography>
        <TextField
          variant="outlined"
          type="text"
          fullWidth
          placeholder="Email"
          className="invoice-input"
          value={invoice.companyEmail}
          name="companyEmail"
          onChange={onChangeInvoice}
          size="small"
          inputProps={{ min: 0, max: 10, readOnly: disableInvoice }}
          helperText={
            <span
              data-id="form-validation-payment-error"
              data-field="email-receive-invoice"
              data-message={t(error.companyEmail)}
              data-form-name="payment-info"
            >
              {t(error.companyEmail)}
            </span>
          }
          error={!!error.companyEmail}
          data-id="input-email-receive-invoice"
        />
      </div>
    </StyledCreateInvoice>
  );
};

export default CreateInvoice;
